// extracted by mini-css-extract-plugin
module.exports = {"content":"Login_content__1POdX","title":"Login_title__1VBh7","description":"Login_description__1aLBh"};